//
// Sage Dictionary tokens
//
// Note: The contents of this file are generated by Style Dictionary
// and should not be modified directly here.
// See `/style-dictionary` directory for tokens and configurations.
//

// ----------
//
// Category: COLOR
//
// ----------

//
// Type: BASE
//

//
// Static vars for COLOR BASE
//
export const COLOR_BASE_PRIMARY_100_HEX = '#e6f4fe';
export const COLOR_BASE_PRIMARY_100_CODE = 'primary-100';
export const COLOR_BASE_PRIMARY_100_CLASSNAME = 't-sage--color-primary-100';
export const COLOR_BASE_PRIMARY_200_HEX = '#8ecafb';
export const COLOR_BASE_PRIMARY_200_CODE = 'primary-200';
export const COLOR_BASE_PRIMARY_200_CLASSNAME = 't-sage--color-primary-200';
export const COLOR_BASE_PRIMARY_300_HEX = '#0072ef';
export const COLOR_BASE_PRIMARY_300_CODE = 'primary-300';
export const COLOR_BASE_PRIMARY_300_CLASSNAME = 't-sage--color-primary-300';
export const COLOR_BASE_PRIMARY_400_HEX = '#054fb8';
export const COLOR_BASE_PRIMARY_400_CODE = 'primary-400';
export const COLOR_BASE_PRIMARY_400_CLASSNAME = 't-sage--color-primary-400';
export const COLOR_BASE_PRIMARY_500_HEX = '#07265f';
export const COLOR_BASE_PRIMARY_500_CODE = 'primary-500';
export const COLOR_BASE_PRIMARY_500_CLASSNAME = 't-sage--color-primary-500';
export const COLOR_BASE_SAGE_100_HEX = '#ddf8f0';
export const COLOR_BASE_SAGE_100_CODE = 'sage-100';
export const COLOR_BASE_SAGE_100_CLASSNAME = 't-sage--color-sage-100';
export const COLOR_BASE_SAGE_200_HEX = '#86d5bc';
export const COLOR_BASE_SAGE_200_CODE = 'sage-200';
export const COLOR_BASE_SAGE_200_CLASSNAME = 't-sage--color-sage-200';
export const COLOR_BASE_SAGE_300_HEX = '#23856d';
export const COLOR_BASE_SAGE_300_CODE = 'sage-300';
export const COLOR_BASE_SAGE_300_CLASSNAME = 't-sage--color-sage-300';
export const COLOR_BASE_SAGE_400_HEX = '#225d53';
export const COLOR_BASE_SAGE_400_CODE = 'sage-400';
export const COLOR_BASE_SAGE_400_CLASSNAME = 't-sage--color-sage-400';
export const COLOR_BASE_SAGE_500_HEX = '#183e3b';
export const COLOR_BASE_SAGE_500_CODE = 'sage-500';
export const COLOR_BASE_SAGE_500_CLASSNAME = 't-sage--color-sage-500';
export const COLOR_BASE_YELLOW_100_HEX = '#fef8e1';
export const COLOR_BASE_YELLOW_100_CODE = 'yellow-100';
export const COLOR_BASE_YELLOW_100_CLASSNAME = 't-sage--color-yellow-100';
export const COLOR_BASE_YELLOW_200_HEX = '#fad980';
export const COLOR_BASE_YELLOW_200_CODE = 'yellow-200';
export const COLOR_BASE_YELLOW_200_CLASSNAME = 't-sage--color-yellow-200';
export const COLOR_BASE_YELLOW_300_HEX = '#ffc505';
export const COLOR_BASE_YELLOW_300_CODE = 'yellow-300';
export const COLOR_BASE_YELLOW_300_CLASSNAME = 't-sage--color-yellow-300';
export const COLOR_BASE_YELLOW_400_HEX = '#c56a02';
export const COLOR_BASE_YELLOW_400_CODE = 'yellow-400';
export const COLOR_BASE_YELLOW_400_CLASSNAME = 't-sage--color-yellow-400';
export const COLOR_BASE_YELLOW_500_HEX = '#8c3b08';
export const COLOR_BASE_YELLOW_500_CODE = 'yellow-500';
export const COLOR_BASE_YELLOW_500_CLASSNAME = 't-sage--color-yellow-500';
export const COLOR_BASE_RED_100_HEX = '#fff0f0';
export const COLOR_BASE_RED_100_CODE = 'red-100';
export const COLOR_BASE_RED_100_CLASSNAME = 't-sage--color-red-100';
export const COLOR_BASE_RED_200_HEX = '#fdb0aa';
export const COLOR_BASE_RED_200_CODE = 'red-200';
export const COLOR_BASE_RED_200_CLASSNAME = 't-sage--color-red-200';
export const COLOR_BASE_RED_300_HEX = '#cf3c32';
export const COLOR_BASE_RED_300_CODE = 'red-300';
export const COLOR_BASE_RED_300_CLASSNAME = 't-sage--color-red-300';
export const COLOR_BASE_RED_400_HEX = '#99221e';
export const COLOR_BASE_RED_400_CODE = 'red-400';
export const COLOR_BASE_RED_400_CLASSNAME = 't-sage--color-red-400';
export const COLOR_BASE_RED_500_HEX = '#5e0d0d';
export const COLOR_BASE_RED_500_CODE = 'red-500';
export const COLOR_BASE_RED_500_CLASSNAME = 't-sage--color-red-500';
export const COLOR_BASE_ORANGE_100_HEX = '#fef1e1';
export const COLOR_BASE_ORANGE_100_CODE = 'orange-100';
export const COLOR_BASE_ORANGE_100_CLASSNAME = 't-sage--color-orange-100';
export const COLOR_BASE_ORANGE_200_HEX = '#ffb36b';
export const COLOR_BASE_ORANGE_200_CODE = 'orange-200';
export const COLOR_BASE_ORANGE_200_CLASSNAME = 't-sage--color-orange-200';
export const COLOR_BASE_ORANGE_300_HEX = '#fb7e09';
export const COLOR_BASE_ORANGE_300_CODE = 'orange-300';
export const COLOR_BASE_ORANGE_300_CLASSNAME = 't-sage--color-orange-300';
export const COLOR_BASE_ORANGE_400_HEX = '#b3501e';
export const COLOR_BASE_ORANGE_400_CODE = 'orange-400';
export const COLOR_BASE_ORANGE_400_CLASSNAME = 't-sage--color-orange-400';
export const COLOR_BASE_ORANGE_500_HEX = '#5a260c';
export const COLOR_BASE_ORANGE_500_CODE = 'orange-500';
export const COLOR_BASE_ORANGE_500_CLASSNAME = 't-sage--color-orange-500';
export const COLOR_BASE_PURPLE_100_HEX = '#eee4f6';
export const COLOR_BASE_PURPLE_100_CODE = 'purple-100';
export const COLOR_BASE_PURPLE_100_CLASSNAME = 't-sage--color-purple-100';
export const COLOR_BASE_PURPLE_200_HEX = '#d9c2ef';
export const COLOR_BASE_PURPLE_200_CODE = 'purple-200';
export const COLOR_BASE_PURPLE_200_CLASSNAME = 't-sage--color-purple-200';
export const COLOR_BASE_PURPLE_300_HEX = '#8e5ad8';
export const COLOR_BASE_PURPLE_300_CODE = 'purple-300';
export const COLOR_BASE_PURPLE_300_CLASSNAME = 't-sage--color-purple-300';
export const COLOR_BASE_PURPLE_400_HEX = '#50348a';
export const COLOR_BASE_PURPLE_400_CODE = 'purple-400';
export const COLOR_BASE_PURPLE_400_CLASSNAME = 't-sage--color-purple-400';
export const COLOR_BASE_PURPLE_500_HEX = '#381c5e';
export const COLOR_BASE_PURPLE_500_CODE = 'purple-500';
export const COLOR_BASE_PURPLE_500_CLASSNAME = 't-sage--color-purple-500';
export const COLOR_BASE_CHARCOAL_100_HEX = '#8d939a';
export const COLOR_BASE_CHARCOAL_100_CODE = 'charcoal-100';
export const COLOR_BASE_CHARCOAL_100_CLASSNAME = 't-sage--color-charcoal-100';
export const COLOR_BASE_CHARCOAL_200_HEX = '#60666c';
export const COLOR_BASE_CHARCOAL_200_CODE = 'charcoal-200';
export const COLOR_BASE_CHARCOAL_200_CLASSNAME = 't-sage--color-charcoal-200';
export const COLOR_BASE_CHARCOAL_300_HEX = '#43474b';
export const COLOR_BASE_CHARCOAL_300_CODE = 'charcoal-300';
export const COLOR_BASE_CHARCOAL_300_CLASSNAME = 't-sage--color-charcoal-300';
export const COLOR_BASE_CHARCOAL_400_HEX = '#202327';
export const COLOR_BASE_CHARCOAL_400_CODE = 'charcoal-400';
export const COLOR_BASE_CHARCOAL_400_CLASSNAME = 't-sage--color-charcoal-400';
export const COLOR_BASE_CHARCOAL_500_HEX = '#040506';
export const COLOR_BASE_CHARCOAL_500_CODE = 'charcoal-500';
export const COLOR_BASE_CHARCOAL_500_CLASSNAME = 't-sage--color-charcoal-500';
export const COLOR_BASE_GREY_100_HEX = '#f9fafa';
export const COLOR_BASE_GREY_100_CODE = 'grey-100';
export const COLOR_BASE_GREY_100_CLASSNAME = 't-sage--color-grey-100';
export const COLOR_BASE_GREY_200_HEX = '#f6f8f8';
export const COLOR_BASE_GREY_200_CODE = 'grey-200';
export const COLOR_BASE_GREY_200_CLASSNAME = 't-sage--color-grey-200';
export const COLOR_BASE_GREY_300_HEX = '#eceeef';
export const COLOR_BASE_GREY_300_CODE = 'grey-300';
export const COLOR_BASE_GREY_300_CLASSNAME = 't-sage--color-grey-300';
export const COLOR_BASE_GREY_400_HEX = '#d3d5d9';
export const COLOR_BASE_GREY_400_CODE = 'grey-400';
export const COLOR_BASE_GREY_400_CLASSNAME = 't-sage--color-grey-400';
export const COLOR_BASE_GREY_500_HEX = '#b5bac0';
export const COLOR_BASE_GREY_500_CODE = 'grey-500';
export const COLOR_BASE_GREY_500_CLASSNAME = 't-sage--color-grey-500';
export const COLOR_BASE_WHITE_100_HEX = '#fff';
export const COLOR_BASE_WHITE_100_CODE = 'white-100';
export const COLOR_BASE_WHITE_100_CLASSNAME = 't-sage--color-white-100';
export const COLOR_BASE_WHITE_200_HEX = '#fff';
export const COLOR_BASE_WHITE_200_CODE = 'white-200';
export const COLOR_BASE_WHITE_200_CLASSNAME = 't-sage--color-white-200';
export const COLOR_BASE_WHITE_300_HEX = '#fff';
export const COLOR_BASE_WHITE_300_CODE = 'white-300';
export const COLOR_BASE_WHITE_300_CLASSNAME = 't-sage--color-white-300';
export const COLOR_BASE_WHITE_400_HEX = '#fff';
export const COLOR_BASE_WHITE_400_CODE = 'white-400';
export const COLOR_BASE_WHITE_400_CLASSNAME = 't-sage--color-white-400';
export const COLOR_BASE_WHITE_500_HEX = '#fff';
export const COLOR_BASE_WHITE_500_CODE = 'white-500';
export const COLOR_BASE_WHITE_500_CLASSNAME = 't-sage--color-white-500';
export const COLOR_BASE_BLACK_100_HEX = '#000';
export const COLOR_BASE_BLACK_100_CODE = 'black-100';
export const COLOR_BASE_BLACK_100_CLASSNAME = 't-sage--color-black-100';
export const COLOR_BASE_BLACK_200_HEX = '#000';
export const COLOR_BASE_BLACK_200_CODE = 'black-200';
export const COLOR_BASE_BLACK_200_CLASSNAME = 't-sage--color-black-200';
export const COLOR_BASE_BLACK_300_HEX = '#000';
export const COLOR_BASE_BLACK_300_CODE = 'black-300';
export const COLOR_BASE_BLACK_300_CLASSNAME = 't-sage--color-black-300';
export const COLOR_BASE_BLACK_400_HEX = '#000';
export const COLOR_BASE_BLACK_400_CODE = 'black-400';
export const COLOR_BASE_BLACK_400_CLASSNAME = 't-sage--color-black-400';
export const COLOR_BASE_BLACK_500_HEX = '#000';
export const COLOR_BASE_BLACK_500_CODE = 'black-500';
export const COLOR_BASE_BLACK_500_CLASSNAME = 't-sage--color-black-500';

//
// Map for COLOR BASE
//
export const COLOR = {
  PRIMARY: {
    100: {
      HEX: COLOR_BASE_PRIMARY_100_HEX,
      CODE: COLOR_BASE_PRIMARY_100_CODE,
      CLASSNAME: COLOR_BASE_PRIMARY_100_CLASSNAME,
    },
    200: {
      HEX: COLOR_BASE_PRIMARY_200_HEX,
      CODE: COLOR_BASE_PRIMARY_200_CODE,
      CLASSNAME: COLOR_BASE_PRIMARY_200_CLASSNAME,
    },
    300: {
      HEX: COLOR_BASE_PRIMARY_300_HEX,
      CODE: COLOR_BASE_PRIMARY_300_CODE,
      CLASSNAME: COLOR_BASE_PRIMARY_300_CLASSNAME,
    },
    400: {
      HEX: COLOR_BASE_PRIMARY_400_HEX,
      CODE: COLOR_BASE_PRIMARY_400_CODE,
      CLASSNAME: COLOR_BASE_PRIMARY_400_CLASSNAME,
    },
    500: {
      HEX: COLOR_BASE_PRIMARY_500_HEX,
      CODE: COLOR_BASE_PRIMARY_500_CODE,
      CLASSNAME: COLOR_BASE_PRIMARY_500_CLASSNAME,
    },
  },
  SAGE: {
    100: {
      HEX: COLOR_BASE_SAGE_100_HEX,
      CODE: COLOR_BASE_SAGE_100_CODE,
      CLASSNAME: COLOR_BASE_SAGE_100_CLASSNAME,
    },
    200: {
      HEX: COLOR_BASE_SAGE_200_HEX,
      CODE: COLOR_BASE_SAGE_200_CODE,
      CLASSNAME: COLOR_BASE_SAGE_200_CLASSNAME,
    },
    300: {
      HEX: COLOR_BASE_SAGE_300_HEX,
      CODE: COLOR_BASE_SAGE_300_CODE,
      CLASSNAME: COLOR_BASE_SAGE_300_CLASSNAME,
    },
    400: {
      HEX: COLOR_BASE_SAGE_400_HEX,
      CODE: COLOR_BASE_SAGE_400_CODE,
      CLASSNAME: COLOR_BASE_SAGE_400_CLASSNAME,
    },
    500: {
      HEX: COLOR_BASE_SAGE_500_HEX,
      CODE: COLOR_BASE_SAGE_500_CODE,
      CLASSNAME: COLOR_BASE_SAGE_500_CLASSNAME,
    },
  },
  YELLOW: {
    100: {
      HEX: COLOR_BASE_YELLOW_100_HEX,
      CODE: COLOR_BASE_YELLOW_100_CODE,
      CLASSNAME: COLOR_BASE_YELLOW_100_CLASSNAME,
    },
    200: {
      HEX: COLOR_BASE_YELLOW_200_HEX,
      CODE: COLOR_BASE_YELLOW_200_CODE,
      CLASSNAME: COLOR_BASE_YELLOW_200_CLASSNAME,
    },
    300: {
      HEX: COLOR_BASE_YELLOW_300_HEX,
      CODE: COLOR_BASE_YELLOW_300_CODE,
      CLASSNAME: COLOR_BASE_YELLOW_300_CLASSNAME,
    },
    400: {
      HEX: COLOR_BASE_YELLOW_400_HEX,
      CODE: COLOR_BASE_YELLOW_400_CODE,
      CLASSNAME: COLOR_BASE_YELLOW_400_CLASSNAME,
    },
    500: {
      HEX: COLOR_BASE_YELLOW_500_HEX,
      CODE: COLOR_BASE_YELLOW_500_CODE,
      CLASSNAME: COLOR_BASE_YELLOW_500_CLASSNAME,
    },
  },
  RED: {
    100: {
      HEX: COLOR_BASE_RED_100_HEX,
      CODE: COLOR_BASE_RED_100_CODE,
      CLASSNAME: COLOR_BASE_RED_100_CLASSNAME,
    },
    200: {
      HEX: COLOR_BASE_RED_200_HEX,
      CODE: COLOR_BASE_RED_200_CODE,
      CLASSNAME: COLOR_BASE_RED_200_CLASSNAME,
    },
    300: {
      HEX: COLOR_BASE_RED_300_HEX,
      CODE: COLOR_BASE_RED_300_CODE,
      CLASSNAME: COLOR_BASE_RED_300_CLASSNAME,
    },
    400: {
      HEX: COLOR_BASE_RED_400_HEX,
      CODE: COLOR_BASE_RED_400_CODE,
      CLASSNAME: COLOR_BASE_RED_400_CLASSNAME,
    },
    500: {
      HEX: COLOR_BASE_RED_500_HEX,
      CODE: COLOR_BASE_RED_500_CODE,
      CLASSNAME: COLOR_BASE_RED_500_CLASSNAME,
    },
  },
  ORANGE: {
    100: {
      HEX: COLOR_BASE_ORANGE_100_HEX,
      CODE: COLOR_BASE_ORANGE_100_CODE,
      CLASSNAME: COLOR_BASE_ORANGE_100_CLASSNAME,
    },
    200: {
      HEX: COLOR_BASE_ORANGE_200_HEX,
      CODE: COLOR_BASE_ORANGE_200_CODE,
      CLASSNAME: COLOR_BASE_ORANGE_200_CLASSNAME,
    },
    300: {
      HEX: COLOR_BASE_ORANGE_300_HEX,
      CODE: COLOR_BASE_ORANGE_300_CODE,
      CLASSNAME: COLOR_BASE_ORANGE_300_CLASSNAME,
    },
    400: {
      HEX: COLOR_BASE_ORANGE_400_HEX,
      CODE: COLOR_BASE_ORANGE_400_CODE,
      CLASSNAME: COLOR_BASE_ORANGE_400_CLASSNAME,
    },
    500: {
      HEX: COLOR_BASE_ORANGE_500_HEX,
      CODE: COLOR_BASE_ORANGE_500_CODE,
      CLASSNAME: COLOR_BASE_ORANGE_500_CLASSNAME,
    },
  },
  PURPLE: {
    100: {
      HEX: COLOR_BASE_PURPLE_100_HEX,
      CODE: COLOR_BASE_PURPLE_100_CODE,
      CLASSNAME: COLOR_BASE_PURPLE_100_CLASSNAME,
    },
    200: {
      HEX: COLOR_BASE_PURPLE_200_HEX,
      CODE: COLOR_BASE_PURPLE_200_CODE,
      CLASSNAME: COLOR_BASE_PURPLE_200_CLASSNAME,
    },
    300: {
      HEX: COLOR_BASE_PURPLE_300_HEX,
      CODE: COLOR_BASE_PURPLE_300_CODE,
      CLASSNAME: COLOR_BASE_PURPLE_300_CLASSNAME,
    },
    400: {
      HEX: COLOR_BASE_PURPLE_400_HEX,
      CODE: COLOR_BASE_PURPLE_400_CODE,
      CLASSNAME: COLOR_BASE_PURPLE_400_CLASSNAME,
    },
    500: {
      HEX: COLOR_BASE_PURPLE_500_HEX,
      CODE: COLOR_BASE_PURPLE_500_CODE,
      CLASSNAME: COLOR_BASE_PURPLE_500_CLASSNAME,
    },
  },
  CHARCOAL: {
    100: {
      HEX: COLOR_BASE_CHARCOAL_100_HEX,
      CODE: COLOR_BASE_CHARCOAL_100_CODE,
      CLASSNAME: COLOR_BASE_CHARCOAL_100_CLASSNAME,
    },
    200: {
      HEX: COLOR_BASE_CHARCOAL_200_HEX,
      CODE: COLOR_BASE_CHARCOAL_200_CODE,
      CLASSNAME: COLOR_BASE_CHARCOAL_200_CLASSNAME,
    },
    300: {
      HEX: COLOR_BASE_CHARCOAL_300_HEX,
      CODE: COLOR_BASE_CHARCOAL_300_CODE,
      CLASSNAME: COLOR_BASE_CHARCOAL_300_CLASSNAME,
    },
    400: {
      HEX: COLOR_BASE_CHARCOAL_400_HEX,
      CODE: COLOR_BASE_CHARCOAL_400_CODE,
      CLASSNAME: COLOR_BASE_CHARCOAL_400_CLASSNAME,
    },
    500: {
      HEX: COLOR_BASE_CHARCOAL_500_HEX,
      CODE: COLOR_BASE_CHARCOAL_500_CODE,
      CLASSNAME: COLOR_BASE_CHARCOAL_500_CLASSNAME,
    },
  },
  GREY: {
    100: {
      HEX: COLOR_BASE_GREY_100_HEX,
      CODE: COLOR_BASE_GREY_100_CODE,
      CLASSNAME: COLOR_BASE_GREY_100_CLASSNAME,
    },
    200: {
      HEX: COLOR_BASE_GREY_200_HEX,
      CODE: COLOR_BASE_GREY_200_CODE,
      CLASSNAME: COLOR_BASE_GREY_200_CLASSNAME,
    },
    300: {
      HEX: COLOR_BASE_GREY_300_HEX,
      CODE: COLOR_BASE_GREY_300_CODE,
      CLASSNAME: COLOR_BASE_GREY_300_CLASSNAME,
    },
    400: {
      HEX: COLOR_BASE_GREY_400_HEX,
      CODE: COLOR_BASE_GREY_400_CODE,
      CLASSNAME: COLOR_BASE_GREY_400_CLASSNAME,
    },
    500: {
      HEX: COLOR_BASE_GREY_500_HEX,
      CODE: COLOR_BASE_GREY_500_CODE,
      CLASSNAME: COLOR_BASE_GREY_500_CLASSNAME,
    },
  },
  WHITE: {
    100: {
      HEX: COLOR_BASE_WHITE_100_HEX,
      CODE: COLOR_BASE_WHITE_100_CODE,
      CLASSNAME: COLOR_BASE_WHITE_100_CLASSNAME,
    },
    200: {
      HEX: COLOR_BASE_WHITE_200_HEX,
      CODE: COLOR_BASE_WHITE_200_CODE,
      CLASSNAME: COLOR_BASE_WHITE_200_CLASSNAME,
    },
    300: {
      HEX: COLOR_BASE_WHITE_300_HEX,
      CODE: COLOR_BASE_WHITE_300_CODE,
      CLASSNAME: COLOR_BASE_WHITE_300_CLASSNAME,
    },
    400: {
      HEX: COLOR_BASE_WHITE_400_HEX,
      CODE: COLOR_BASE_WHITE_400_CODE,
      CLASSNAME: COLOR_BASE_WHITE_400_CLASSNAME,
    },
    500: {
      HEX: COLOR_BASE_WHITE_500_HEX,
      CODE: COLOR_BASE_WHITE_500_CODE,
      CLASSNAME: COLOR_BASE_WHITE_500_CLASSNAME,
    },
  },
  BLACK: {
    100: {
      HEX: COLOR_BASE_BLACK_100_HEX,
      CODE: COLOR_BASE_BLACK_100_CODE,
      CLASSNAME: COLOR_BASE_BLACK_100_CLASSNAME,
    },
    200: {
      HEX: COLOR_BASE_BLACK_200_HEX,
      CODE: COLOR_BASE_BLACK_200_CODE,
      CLASSNAME: COLOR_BASE_BLACK_200_CLASSNAME,
    },
    300: {
      HEX: COLOR_BASE_BLACK_300_HEX,
      CODE: COLOR_BASE_BLACK_300_CODE,
      CLASSNAME: COLOR_BASE_BLACK_300_CLASSNAME,
    },
    400: {
      HEX: COLOR_BASE_BLACK_400_HEX,
      CODE: COLOR_BASE_BLACK_400_CODE,
      CLASSNAME: COLOR_BASE_BLACK_400_CLASSNAME,
    },
    500: {
      HEX: COLOR_BASE_BLACK_500_HEX,
      CODE: COLOR_BASE_BLACK_500_CODE,
      CLASSNAME: COLOR_BASE_BLACK_500_CLASSNAME,
    },
  },
};

//
// Type: COMBOS
//

//
// Static vars for COLOR COMBOS
//
export const COLOR_COMBOS_DRAFT_DEFAULT_FOREGROUND = '#202327';
export const COLOR_COMBOS_DRAFT_DEFAULT_FOREGROUND_ACCENT = '#040506';
export const COLOR_COMBOS_DRAFT_DEFAULT_BACKGROUND = '#eceeef';
export const COLOR_COMBOS_DRAFT_DEFAULT_BACKGROUND_ACCENT = '#d3d5d9';
export const COLOR_COMBOS_DRAFT_DEFAULT_ICON_BACKGROUND_ACCENT = '#60666c';
export const COLOR_COMBOS_DRAFT_SUBTLE_FOREGROUND = '#60666c';
export const COLOR_COMBOS_DRAFT_SUBTLE_FOREGROUND_ACCENT = '#8d939a';
export const COLOR_COMBOS_DRAFT_SUBTLE_BACKGROUND = '#8d939a';
export const COLOR_COMBOS_DRAFT_BOLD_FOREGROUND = '#f6f8f8';
export const COLOR_COMBOS_DRAFT_BOLD_BACKGROUND = '#202327';
export const COLOR_COMBOS_PUBLISHED_DEFAULT_FOREGROUND = '#225d53';
export const COLOR_COMBOS_PUBLISHED_DEFAULT_FOREGROUND_ACCENT = '#183e3b';
export const COLOR_COMBOS_PUBLISHED_DEFAULT_BACKGROUND = '#ddf8f0';
export const COLOR_COMBOS_PUBLISHED_DEFAULT_BACKGROUND_ACCENT = '#86d5bc';
export const COLOR_COMBOS_PUBLISHED_DEFAULT_ICON_BACKGROUND_ACCENT = '#23856d';
export const COLOR_COMBOS_PUBLISHED_SUBTLE_FOREGROUND = '#225d53';
export const COLOR_COMBOS_PUBLISHED_SUBTLE_FOREGROUND_ACCENT = '#23856d';
export const COLOR_COMBOS_PUBLISHED_SUBTLE_BACKGROUND = '#23856d';
export const COLOR_COMBOS_PUBLISHED_BOLD_FOREGROUND = '#fff';
export const COLOR_COMBOS_PUBLISHED_BOLD_BACKGROUND = '#23856d';
export const COLOR_COMBOS_INFO_DEFAULT_FOREGROUND = '#054fb8';
export const COLOR_COMBOS_INFO_DEFAULT_FOREGROUND_ACCENT = '#07265f';
export const COLOR_COMBOS_INFO_DEFAULT_BACKGROUND = '#e6f4fe';
export const COLOR_COMBOS_INFO_DEFAULT_BACKGROUND_ACCENT = '#8ecafb';
export const COLOR_COMBOS_INFO_DEFAULT_ICON_BACKGROUND_ACCENT = '#0072ef';
export const COLOR_COMBOS_INFO_SUBTLE_FOREGROUND = '#054fb8';
export const COLOR_COMBOS_INFO_SUBTLE_FOREGROUND_ACCENT = '#0072ef';
export const COLOR_COMBOS_INFO_SUBTLE_BACKGROUND = '#8ecafb';
export const COLOR_COMBOS_INFO_BOLD_FOREGROUND = '#e6f4fe';
export const COLOR_COMBOS_INFO_BOLD_BACKGROUND = '#0072ef';
export const COLOR_COMBOS_LOCKED_DEFAULT_FOREGROUND = '#50348a';
export const COLOR_COMBOS_LOCKED_DEFAULT_FOREGROUND_ACCENT = '#381c5e';
export const COLOR_COMBOS_LOCKED_DEFAULT_BACKGROUND = '#eee4f6';
export const COLOR_COMBOS_LOCKED_DEFAULT_BACKGROUND_ACCENT = '#d9c2ef';
export const COLOR_COMBOS_LOCKED_DEFAULT_ICON_BACKGROUND_ACCENT = '#8e5ad8';
export const COLOR_COMBOS_LOCKED_SUBTLE_FOREGROUND = '#50348a';
export const COLOR_COMBOS_LOCKED_SUBTLE_FOREGROUND_ACCENT = '#8e5ad8';
export const COLOR_COMBOS_LOCKED_SUBTLE_BACKGROUND = '#d9c2ef';
export const COLOR_COMBOS_LOCKED_BOLD_FOREGROUND = '#eee4f6';
export const COLOR_COMBOS_LOCKED_BOLD_BACKGROUND = '#8e5ad8';
export const COLOR_COMBOS_WARNING_DEFAULT_FOREGROUND = '#c56a02';
export const COLOR_COMBOS_WARNING_DEFAULT_FOREGROUND_ACCENT = '#8c3b08';
export const COLOR_COMBOS_WARNING_DEFAULT_BACKGROUND = '#fef8e1';
export const COLOR_COMBOS_WARNING_DEFAULT_BACKGROUND_ACCENT = '#fad980';
export const COLOR_COMBOS_WARNING_DEFAULT_ICON_BACKGROUND_ACCENT = '#c56a02';
export const COLOR_COMBOS_WARNING_SUBTLE_FOREGROUND = '#c56a02';
export const COLOR_COMBOS_WARNING_SUBTLE_FOREGROUND_ACCENT = '#ffc505';
export const COLOR_COMBOS_WARNING_SUBTLE_BACKGROUND = '#ffc505';
export const COLOR_COMBOS_WARNING_BOLD_FOREGROUND = '#fff';
export const COLOR_COMBOS_WARNING_BOLD_BACKGROUND = '#ffc505';
export const COLOR_COMBOS_DANGER_DEFAULT_FOREGROUND = '#99221e';
export const COLOR_COMBOS_DANGER_DEFAULT_FOREGROUND_ACCENT = '#5e0d0d';
export const COLOR_COMBOS_DANGER_DEFAULT_BACKGROUND = '#fff0f0';
export const COLOR_COMBOS_DANGER_DEFAULT_BACKGROUND_ACCENT = '#fdb0aa';
export const COLOR_COMBOS_DANGER_DEFAULT_ICON_BACKGROUND_ACCENT = '#cf3c32';
export const COLOR_COMBOS_DANGER_SUBTLE_FOREGROUND = '#99221e';
export const COLOR_COMBOS_DANGER_SUBTLE_FOREGROUND_ACCENT = '#fdb0aa';
export const COLOR_COMBOS_DANGER_SUBTLE_BACKGROUND = '#fdb0aa';
export const COLOR_COMBOS_DANGER_BOLD_FOREGROUND = '#fff0f0';
export const COLOR_COMBOS_DANGER_BOLD_BACKGROUND = '#fdb0aa';
export const COLOR_COMBOS_PRIMARY_DEFAULT_FOREGROUND = '#fff';
export const COLOR_COMBOS_PRIMARY_DEFAULT_FOREGROUND_ACCENT = '#fff';
export const COLOR_COMBOS_PRIMARY_DEFAULT_BACKGROUND = '#8ecafb';
export const COLOR_COMBOS_PRIMARY_SUBTLE_FOREGROUND = '#fff';
export const COLOR_COMBOS_PRIMARY_SUBTLE_FOREGROUND_ACCENT = '#fff';
export const COLOR_COMBOS_PRIMARY_SUBTLE_BACKGROUND = '#8ecafb';
export const COLOR_COMBOS_PRIMARY_BOLD_FOREGROUND = '#fff';
export const COLOR_COMBOS_PRIMARY_BOLD_BACKGROUND = '#8ecafb';

//
// Map for COLOR COMBOS
//
export const COLOR_COMBOS = {
  DRAFT: {
    DEFAULT: {
      FOREGROUND: COLOR_COMBOS_DRAFT_DEFAULT_FOREGROUND,
      FOREGROUND_ACCENT: COLOR_COMBOS_DRAFT_DEFAULT_FOREGROUND_ACCENT,
      BACKGROUND: COLOR_COMBOS_DRAFT_DEFAULT_BACKGROUND,
      BACKGROUND_ACCENT: COLOR_COMBOS_DRAFT_DEFAULT_BACKGROUND_ACCENT,
      ICON_BACKGROUND_ACCENT: COLOR_COMBOS_DRAFT_DEFAULT_ICON_BACKGROUND_ACCENT,
    },
    SUBTLE: {
      FOREGROUND: COLOR_COMBOS_DRAFT_SUBTLE_FOREGROUND,
      FOREGROUND_ACCENT: COLOR_COMBOS_DRAFT_SUBTLE_FOREGROUND_ACCENT,
      BACKGROUND: COLOR_COMBOS_DRAFT_SUBTLE_BACKGROUND,
    },
    BOLD: {
      FOREGROUND: COLOR_COMBOS_DRAFT_BOLD_FOREGROUND,
      BACKGROUND: COLOR_COMBOS_DRAFT_BOLD_BACKGROUND,
    },
  },
  PUBLISHED: {
    DEFAULT: {
      FOREGROUND: COLOR_COMBOS_PUBLISHED_DEFAULT_FOREGROUND,
      FOREGROUND_ACCENT: COLOR_COMBOS_PUBLISHED_DEFAULT_FOREGROUND_ACCENT,
      BACKGROUND: COLOR_COMBOS_PUBLISHED_DEFAULT_BACKGROUND,
      BACKGROUND_ACCENT: COLOR_COMBOS_PUBLISHED_DEFAULT_BACKGROUND_ACCENT,
      ICON_BACKGROUND_ACCENT: COLOR_COMBOS_PUBLISHED_DEFAULT_ICON_BACKGROUND_ACCENT,
    },
    SUBTLE: {
      FOREGROUND: COLOR_COMBOS_PUBLISHED_SUBTLE_FOREGROUND,
      FOREGROUND_ACCENT: COLOR_COMBOS_PUBLISHED_SUBTLE_FOREGROUND_ACCENT,
      BACKGROUND: COLOR_COMBOS_PUBLISHED_SUBTLE_BACKGROUND,
    },
    BOLD: {
      FOREGROUND: COLOR_COMBOS_PUBLISHED_BOLD_FOREGROUND,
      BACKGROUND: COLOR_COMBOS_PUBLISHED_BOLD_BACKGROUND,
    },
  },
  INFO: {
    DEFAULT: {
      FOREGROUND: COLOR_COMBOS_INFO_DEFAULT_FOREGROUND,
      FOREGROUND_ACCENT: COLOR_COMBOS_INFO_DEFAULT_FOREGROUND_ACCENT,
      BACKGROUND: COLOR_COMBOS_INFO_DEFAULT_BACKGROUND,
      BACKGROUND_ACCENT: COLOR_COMBOS_INFO_DEFAULT_BACKGROUND_ACCENT,
      ICON_BACKGROUND_ACCENT: COLOR_COMBOS_INFO_DEFAULT_ICON_BACKGROUND_ACCENT,
    },
    SUBTLE: {
      FOREGROUND: COLOR_COMBOS_INFO_SUBTLE_FOREGROUND,
      FOREGROUND_ACCENT: COLOR_COMBOS_INFO_SUBTLE_FOREGROUND_ACCENT,
      BACKGROUND: COLOR_COMBOS_INFO_SUBTLE_BACKGROUND,
    },
    BOLD: {
      FOREGROUND: COLOR_COMBOS_INFO_BOLD_FOREGROUND,
      BACKGROUND: COLOR_COMBOS_INFO_BOLD_BACKGROUND,
    },
  },
  LOCKED: {
    DEFAULT: {
      FOREGROUND: COLOR_COMBOS_LOCKED_DEFAULT_FOREGROUND,
      FOREGROUND_ACCENT: COLOR_COMBOS_LOCKED_DEFAULT_FOREGROUND_ACCENT,
      BACKGROUND: COLOR_COMBOS_LOCKED_DEFAULT_BACKGROUND,
      BACKGROUND_ACCENT: COLOR_COMBOS_LOCKED_DEFAULT_BACKGROUND_ACCENT,
      ICON_BACKGROUND_ACCENT: COLOR_COMBOS_LOCKED_DEFAULT_ICON_BACKGROUND_ACCENT,
    },
    SUBTLE: {
      FOREGROUND: COLOR_COMBOS_LOCKED_SUBTLE_FOREGROUND,
      FOREGROUND_ACCENT: COLOR_COMBOS_LOCKED_SUBTLE_FOREGROUND_ACCENT,
      BACKGROUND: COLOR_COMBOS_LOCKED_SUBTLE_BACKGROUND,
    },
    BOLD: {
      FOREGROUND: COLOR_COMBOS_LOCKED_BOLD_FOREGROUND,
      BACKGROUND: COLOR_COMBOS_LOCKED_BOLD_BACKGROUND,
    },
  },
  WARNING: {
    DEFAULT: {
      FOREGROUND: COLOR_COMBOS_WARNING_DEFAULT_FOREGROUND,
      FOREGROUND_ACCENT: COLOR_COMBOS_WARNING_DEFAULT_FOREGROUND_ACCENT,
      BACKGROUND: COLOR_COMBOS_WARNING_DEFAULT_BACKGROUND,
      BACKGROUND_ACCENT: COLOR_COMBOS_WARNING_DEFAULT_BACKGROUND_ACCENT,
      ICON_BACKGROUND_ACCENT: COLOR_COMBOS_WARNING_DEFAULT_ICON_BACKGROUND_ACCENT,
    },
    SUBTLE: {
      FOREGROUND: COLOR_COMBOS_WARNING_SUBTLE_FOREGROUND,
      FOREGROUND_ACCENT: COLOR_COMBOS_WARNING_SUBTLE_FOREGROUND_ACCENT,
      BACKGROUND: COLOR_COMBOS_WARNING_SUBTLE_BACKGROUND,
    },
    BOLD: {
      FOREGROUND: COLOR_COMBOS_WARNING_BOLD_FOREGROUND,
      BACKGROUND: COLOR_COMBOS_WARNING_BOLD_BACKGROUND,
    },
  },
  DANGER: {
    DEFAULT: {
      FOREGROUND: COLOR_COMBOS_DANGER_DEFAULT_FOREGROUND,
      FOREGROUND_ACCENT: COLOR_COMBOS_DANGER_DEFAULT_FOREGROUND_ACCENT,
      BACKGROUND: COLOR_COMBOS_DANGER_DEFAULT_BACKGROUND,
      BACKGROUND_ACCENT: COLOR_COMBOS_DANGER_DEFAULT_BACKGROUND_ACCENT,
      ICON_BACKGROUND_ACCENT: COLOR_COMBOS_DANGER_DEFAULT_ICON_BACKGROUND_ACCENT,
    },
    SUBTLE: {
      FOREGROUND: COLOR_COMBOS_DANGER_SUBTLE_FOREGROUND,
      FOREGROUND_ACCENT: COLOR_COMBOS_DANGER_SUBTLE_FOREGROUND_ACCENT,
      BACKGROUND: COLOR_COMBOS_DANGER_SUBTLE_BACKGROUND,
    },
    BOLD: {
      FOREGROUND: COLOR_COMBOS_DANGER_BOLD_FOREGROUND,
      BACKGROUND: COLOR_COMBOS_DANGER_BOLD_BACKGROUND,
    },
  },
  PRIMARY: {
    DEFAULT: {
      FOREGROUND: COLOR_COMBOS_PRIMARY_DEFAULT_FOREGROUND,
      FOREGROUND_ACCENT: COLOR_COMBOS_PRIMARY_DEFAULT_FOREGROUND_ACCENT,
      BACKGROUND: COLOR_COMBOS_PRIMARY_DEFAULT_BACKGROUND,
    },
    SUBTLE: {
      FOREGROUND: COLOR_COMBOS_PRIMARY_SUBTLE_FOREGROUND,
      FOREGROUND_ACCENT: COLOR_COMBOS_PRIMARY_SUBTLE_FOREGROUND_ACCENT,
      BACKGROUND: COLOR_COMBOS_PRIMARY_SUBTLE_BACKGROUND,
    },
    BOLD: {
      FOREGROUND: COLOR_COMBOS_PRIMARY_BOLD_FOREGROUND,
      BACKGROUND: COLOR_COMBOS_PRIMARY_BOLD_BACKGROUND,
    },
  },
};

//
// Type: CORE
//

//
// Static vars for COLOR CORE
//
export const COLOR_CORE_PRIMARY = '#0072ef';
export const COLOR_CORE_SAGE = '#23856d';
export const COLOR_CORE_YELLOW = '#ffc505';
export const COLOR_CORE_RED = '#cf3c32';
export const COLOR_CORE_ORANGE = '#fb7e09';
export const COLOR_CORE_PURPLE = '#8e5ad8';
export const COLOR_CORE_CHARCOAL = '#43474b';
export const COLOR_CORE_GREY = '#8d939a';
export const COLOR_CORE_WHITE = '#fff';
export const COLOR_CORE_BLACK = '#000';

//
// Map for COLOR CORE
//
export const COLOR_CORE = {
  PRIMARY: COLOR_CORE_PRIMARY,
  SAGE: COLOR_CORE_SAGE,
  YELLOW: COLOR_CORE_YELLOW,
  RED: COLOR_CORE_RED,
  ORANGE: COLOR_CORE_ORANGE,
  PURPLE: COLOR_CORE_PURPLE,
  CHARCOAL: COLOR_CORE_CHARCOAL,
  GREY: COLOR_CORE_GREY,
  WHITE: COLOR_CORE_WHITE,
  BLACK: COLOR_CORE_BLACK,
};

//
// Type: CUSTOM
//

//
// Static vars for COLOR CUSTOM
//
export const COLOR_CUSTOM_LABEL_PRIMARY_ICON_BACKGROUND_ACCENT = '#3e92ee';
export const COLOR_CUSTOM_LABEL_WARNING_BACKGROUND_ACCENT = '#f9df8b';
export const COLOR_CUSTOM_LABEL_DANGER_BACKGROUND_ACCENT = '#f3988c';
export const COLOR_CUSTOM_LABEL_DANGER_ICON_BACKGROUND_ACCENT = '#da665e';

//
// Map for COLOR CUSTOM
//
export const COLOR_CUSTOM = {
  LABEL_PRIMARY_ICON_BACKGROUND_ACCENT: COLOR_CUSTOM_LABEL_PRIMARY_ICON_BACKGROUND_ACCENT,
  LABEL_WARNING_BACKGROUND_ACCENT: COLOR_CUSTOM_LABEL_WARNING_BACKGROUND_ACCENT,
  LABEL_DANGER_BACKGROUND_ACCENT: COLOR_CUSTOM_LABEL_DANGER_BACKGROUND_ACCENT,
  LABEL_DANGER_ICON_BACKGROUND_ACCENT: COLOR_CUSTOM_LABEL_DANGER_ICON_BACKGROUND_ACCENT,
};

// ----------
//
// Category: CONTENT
//
// ----------

//
// Type: GRID_TEMPLATE
//

//
// Static vars for CONTENT GRID_TEMPLATE
//
export const CONTENT_GRID_TEMPLATE_E_CODE = '.';
export const CONTENT_GRID_TEMPLATE_E_SYMBOL = 'e';
export const CONTENT_GRID_TEMPLATE_E_CLASSNAME = 'sage-grid-template-e';
export const CONTENT_GRID_TEMPLATE_I_CODE = '..';
export const CONTENT_GRID_TEMPLATE_I_SYMBOL = 'i';
export const CONTENT_GRID_TEMPLATE_I_CLASSNAME = 'sage-grid-template-i';
export const CONTENT_GRID_TEMPLATE_S_CODE = '...';
export const CONTENT_GRID_TEMPLATE_S_SYMBOL = 's';
export const CONTENT_GRID_TEMPLATE_S_CLASSNAME = 'sage-grid-template-s';
export const CONTENT_GRID_TEMPLATE_T_CODE = '-';
export const CONTENT_GRID_TEMPLATE_T_SYMBOL = 't';
export const CONTENT_GRID_TEMPLATE_T_CLASSNAME = 'sage-grid-template-t';
export const CONTENT_GRID_TEMPLATE_M_CODE = '--';
export const CONTENT_GRID_TEMPLATE_M_SYMBOL = 'm';
export const CONTENT_GRID_TEMPLATE_M_CLASSNAME = 'sage-grid-template-m';
export const CONTENT_GRID_TEMPLATE_O_CODE = '---';
export const CONTENT_GRID_TEMPLATE_O_SYMBOL = 'o';
export const CONTENT_GRID_TEMPLATE_O_CLASSNAME = 'sage-grid-template-o';
export const CONTENT_GRID_TEMPLATE_SE_CODE = '....';
export const CONTENT_GRID_TEMPLATE_SE_SYMBOL = 'se';
export const CONTENT_GRID_TEMPLATE_SE_CLASSNAME = 'sage-grid-template-se';
export const CONTENT_GRID_TEMPLATE_SI_CODE = '.....';
export const CONTENT_GRID_TEMPLATE_SI_SYMBOL = 'si';
export const CONTENT_GRID_TEMPLATE_SI_CLASSNAME = 'sage-grid-template-si';
export const CONTENT_GRID_TEMPLATE_SS_CODE = '......';
export const CONTENT_GRID_TEMPLATE_SS_SYMBOL = 'ss';
export const CONTENT_GRID_TEMPLATE_SS_CLASSNAME = 'sage-grid-template-ss';
export const CONTENT_GRID_TEMPLATE_OT_CODE = '----';
export const CONTENT_GRID_TEMPLATE_OT_SYMBOL = 'ot';
export const CONTENT_GRID_TEMPLATE_OT_CLASSNAME = 'sage-grid-template-ot';
export const CONTENT_GRID_TEMPLATE_OM_CODE = '-----';
export const CONTENT_GRID_TEMPLATE_OM_SYMBOL = 'om';
export const CONTENT_GRID_TEMPLATE_OM_CLASSNAME = 'sage-grid-template-om';
export const CONTENT_GRID_TEMPLATE_OO_CODE = '------';
export const CONTENT_GRID_TEMPLATE_OO_SYMBOL = 'oo';
export const CONTENT_GRID_TEMPLATE_OO_CLASSNAME = 'sage-grid-template-oo';
export const CONTENT_GRID_TEMPLATE_ET_CODE = '.-';
export const CONTENT_GRID_TEMPLATE_ET_SYMBOL = 'et';
export const CONTENT_GRID_TEMPLATE_ET_CLASSNAME = 'sage-grid-template-et';
export const CONTENT_GRID_TEMPLATE_EM_CODE = '.--';
export const CONTENT_GRID_TEMPLATE_EM_SYMBOL = 'em';
export const CONTENT_GRID_TEMPLATE_EM_CLASSNAME = 'sage-grid-template-em';
export const CONTENT_GRID_TEMPLATE_EO_CODE = '.---';
export const CONTENT_GRID_TEMPLATE_EO_SYMBOL = 'eo';
export const CONTENT_GRID_TEMPLATE_EO_CLASSNAME = 'sage-grid-template-eo';
export const CONTENT_GRID_TEMPLATE_IT_CODE = '..-';
export const CONTENT_GRID_TEMPLATE_IT_SYMBOL = 'it';
export const CONTENT_GRID_TEMPLATE_IT_CLASSNAME = 'sage-grid-template-it';
export const CONTENT_GRID_TEMPLATE_IM_CODE = '..--';
export const CONTENT_GRID_TEMPLATE_IM_SYMBOL = 'im';
export const CONTENT_GRID_TEMPLATE_IM_CLASSNAME = 'sage-grid-template-im';
export const CONTENT_GRID_TEMPLATE_IO_CODE = '..---';
export const CONTENT_GRID_TEMPLATE_IO_SYMBOL = 'io';
export const CONTENT_GRID_TEMPLATE_IO_CLASSNAME = 'sage-grid-template-io';
export const CONTENT_GRID_TEMPLATE_ST_CODE = '...-';
export const CONTENT_GRID_TEMPLATE_ST_SYMBOL = 'st';
export const CONTENT_GRID_TEMPLATE_ST_CLASSNAME = 'sage-grid-template-st';
export const CONTENT_GRID_TEMPLATE_SM_CODE = '...--';
export const CONTENT_GRID_TEMPLATE_SM_SYMBOL = 'sm';
export const CONTENT_GRID_TEMPLATE_SM_CLASSNAME = 'sage-grid-template-sm';
export const CONTENT_GRID_TEMPLATE_SO_CODE = '...---';
export const CONTENT_GRID_TEMPLATE_SO_SYMBOL = 'so';
export const CONTENT_GRID_TEMPLATE_SO_CLASSNAME = 'sage-grid-template-so';
export const CONTENT_GRID_TEMPLATE_TE_CODE = '-.';
export const CONTENT_GRID_TEMPLATE_TE_SYMBOL = 'te';
export const CONTENT_GRID_TEMPLATE_TE_CLASSNAME = 'sage-grid-template-te';
export const CONTENT_GRID_TEMPLATE_TI_CODE = '-..';
export const CONTENT_GRID_TEMPLATE_TI_SYMBOL = 'ti';
export const CONTENT_GRID_TEMPLATE_TI_CLASSNAME = 'sage-grid-template-ti';
export const CONTENT_GRID_TEMPLATE_TS_CODE = '-...';
export const CONTENT_GRID_TEMPLATE_TS_SYMBOL = 'ts';
export const CONTENT_GRID_TEMPLATE_TS_CLASSNAME = 'sage-grid-template-ts';
export const CONTENT_GRID_TEMPLATE_ME_CODE = '--.';
export const CONTENT_GRID_TEMPLATE_ME_SYMBOL = 'me';
export const CONTENT_GRID_TEMPLATE_ME_CLASSNAME = 'sage-grid-template-me';
export const CONTENT_GRID_TEMPLATE_MI_CODE = '--..';
export const CONTENT_GRID_TEMPLATE_MI_SYMBOL = 'mi';
export const CONTENT_GRID_TEMPLATE_MI_CLASSNAME = 'sage-grid-template-mi';
export const CONTENT_GRID_TEMPLATE_MS_CODE = '--...';
export const CONTENT_GRID_TEMPLATE_MS_SYMBOL = 'ms';
export const CONTENT_GRID_TEMPLATE_MS_CLASSNAME = 'sage-grid-template-ms';
export const CONTENT_GRID_TEMPLATE_OE_CODE = '---.';
export const CONTENT_GRID_TEMPLATE_OE_SYMBOL = 'oe';
export const CONTENT_GRID_TEMPLATE_OE_CLASSNAME = 'sage-grid-template-oe';
export const CONTENT_GRID_TEMPLATE_OI_CODE = '---..';
export const CONTENT_GRID_TEMPLATE_OI_SYMBOL = 'oi';
export const CONTENT_GRID_TEMPLATE_OI_CLASSNAME = 'sage-grid-template-oi';
export const CONTENT_GRID_TEMPLATE_OS_CODE = '---...';
export const CONTENT_GRID_TEMPLATE_OS_SYMBOL = 'os';
export const CONTENT_GRID_TEMPLATE_OS_CLASSNAME = 'sage-grid-template-os';
export const CONTENT_GRID_TEMPLATE_ETE_CODE = '.-.';
export const CONTENT_GRID_TEMPLATE_ETE_SYMBOL = 'ete';
export const CONTENT_GRID_TEMPLATE_ETE_CLASSNAME = 'sage-grid-template-ete';
export const CONTENT_GRID_TEMPLATE_ETI_CODE = '.-..';
export const CONTENT_GRID_TEMPLATE_ETI_SYMBOL = 'eti';
export const CONTENT_GRID_TEMPLATE_ETI_CLASSNAME = 'sage-grid-template-eti';
export const CONTENT_GRID_TEMPLATE_ETS_CODE = '.-...';
export const CONTENT_GRID_TEMPLATE_ETS_SYMBOL = 'ets';
export const CONTENT_GRID_TEMPLATE_ETS_CLASSNAME = 'sage-grid-template-ets';
export const CONTENT_GRID_TEMPLATE_EME_CODE = '.--.';
export const CONTENT_GRID_TEMPLATE_EME_SYMBOL = 'eme';
export const CONTENT_GRID_TEMPLATE_EME_CLASSNAME = 'sage-grid-template-eme';
export const CONTENT_GRID_TEMPLATE_EMI_CODE = '.--..';
export const CONTENT_GRID_TEMPLATE_EMI_SYMBOL = 'emi';
export const CONTENT_GRID_TEMPLATE_EMI_CLASSNAME = 'sage-grid-template-emi';
export const CONTENT_GRID_TEMPLATE_EMS_CODE = '.--...';
export const CONTENT_GRID_TEMPLATE_EMS_SYMBOL = 'ems';
export const CONTENT_GRID_TEMPLATE_EMS_CLASSNAME = 'sage-grid-template-ems';
export const CONTENT_GRID_TEMPLATE_EOE_CODE = '.---.';
export const CONTENT_GRID_TEMPLATE_EOE_SYMBOL = 'eoe';
export const CONTENT_GRID_TEMPLATE_EOE_CLASSNAME = 'sage-grid-template-eoe';
export const CONTENT_GRID_TEMPLATE_EOI_CODE = '.---..';
export const CONTENT_GRID_TEMPLATE_EOI_SYMBOL = 'eoi';
export const CONTENT_GRID_TEMPLATE_EOI_CLASSNAME = 'sage-grid-template-eoi';
export const CONTENT_GRID_TEMPLATE_EOS_CODE = '.---...';
export const CONTENT_GRID_TEMPLATE_EOS_SYMBOL = 'eos';
export const CONTENT_GRID_TEMPLATE_EOS_CLASSNAME = 'sage-grid-template-eos';
export const CONTENT_GRID_TEMPLATE_ITE_CODE = '..-.';
export const CONTENT_GRID_TEMPLATE_ITE_SYMBOL = 'ite';
export const CONTENT_GRID_TEMPLATE_ITE_CLASSNAME = 'sage-grid-template-ite';
export const CONTENT_GRID_TEMPLATE_ITI_CODE = '..-..';
export const CONTENT_GRID_TEMPLATE_ITI_SYMBOL = 'iti';
export const CONTENT_GRID_TEMPLATE_ITI_CLASSNAME = 'sage-grid-template-iti';
export const CONTENT_GRID_TEMPLATE_ITS_CODE = '..-...';
export const CONTENT_GRID_TEMPLATE_ITS_SYMBOL = 'its';
export const CONTENT_GRID_TEMPLATE_ITS_CLASSNAME = 'sage-grid-template-its';
export const CONTENT_GRID_TEMPLATE_IME_CODE = '..--.';
export const CONTENT_GRID_TEMPLATE_IME_SYMBOL = 'ime';
export const CONTENT_GRID_TEMPLATE_IME_CLASSNAME = 'sage-grid-template-ime';
export const CONTENT_GRID_TEMPLATE_IMI_CODE = '..--..';
export const CONTENT_GRID_TEMPLATE_IMI_SYMBOL = 'imi';
export const CONTENT_GRID_TEMPLATE_IMI_CLASSNAME = 'sage-grid-template-imi';
export const CONTENT_GRID_TEMPLATE_IMS_CODE = '..--...';
export const CONTENT_GRID_TEMPLATE_IMS_SYMBOL = 'ims';
export const CONTENT_GRID_TEMPLATE_IMS_CLASSNAME = 'sage-grid-template-ims';
export const CONTENT_GRID_TEMPLATE_IOE_CODE = '..---.';
export const CONTENT_GRID_TEMPLATE_IOE_SYMBOL = 'ioe';
export const CONTENT_GRID_TEMPLATE_IOE_CLASSNAME = 'sage-grid-template-ioe';
export const CONTENT_GRID_TEMPLATE_IOI_CODE = '..---..';
export const CONTENT_GRID_TEMPLATE_IOI_SYMBOL = 'ioi';
export const CONTENT_GRID_TEMPLATE_IOI_CLASSNAME = 'sage-grid-template-ioi';
export const CONTENT_GRID_TEMPLATE_IOS_CODE = '..---...';
export const CONTENT_GRID_TEMPLATE_IOS_SYMBOL = 'ios';
export const CONTENT_GRID_TEMPLATE_IOS_CLASSNAME = 'sage-grid-template-ios';
export const CONTENT_GRID_TEMPLATE_STE_CODE = '...-.';
export const CONTENT_GRID_TEMPLATE_STE_SYMBOL = 'ste';
export const CONTENT_GRID_TEMPLATE_STE_CLASSNAME = 'sage-grid-template-ste';
export const CONTENT_GRID_TEMPLATE_STI_CODE = '...-..';
export const CONTENT_GRID_TEMPLATE_STI_SYMBOL = 'sti';
export const CONTENT_GRID_TEMPLATE_STI_CLASSNAME = 'sage-grid-template-sti';
export const CONTENT_GRID_TEMPLATE_STS_CODE = '...-...';
export const CONTENT_GRID_TEMPLATE_STS_SYMBOL = 'sts';
export const CONTENT_GRID_TEMPLATE_STS_CLASSNAME = 'sage-grid-template-sts';
export const CONTENT_GRID_TEMPLATE_SME_CODE = '...--.';
export const CONTENT_GRID_TEMPLATE_SME_SYMBOL = 'sme';
export const CONTENT_GRID_TEMPLATE_SME_CLASSNAME = 'sage-grid-template-sme';
export const CONTENT_GRID_TEMPLATE_SMI_CODE = '...--..';
export const CONTENT_GRID_TEMPLATE_SMI_SYMBOL = 'smi';
export const CONTENT_GRID_TEMPLATE_SMI_CLASSNAME = 'sage-grid-template-smi';
export const CONTENT_GRID_TEMPLATE_SMS_CODE = '...--...';
export const CONTENT_GRID_TEMPLATE_SMS_SYMBOL = 'sms';
export const CONTENT_GRID_TEMPLATE_SMS_CLASSNAME = 'sage-grid-template-sms';
export const CONTENT_GRID_TEMPLATE_SOE_CODE = '...---.';
export const CONTENT_GRID_TEMPLATE_SOE_SYMBOL = 'soe';
export const CONTENT_GRID_TEMPLATE_SOE_CLASSNAME = 'sage-grid-template-soe';
export const CONTENT_GRID_TEMPLATE_SOI_CODE = '...---..';
export const CONTENT_GRID_TEMPLATE_SOI_SYMBOL = 'soi';
export const CONTENT_GRID_TEMPLATE_SOI_CLASSNAME = 'sage-grid-template-soi';
export const CONTENT_GRID_TEMPLATE_SOS_CODE = '...---...';
export const CONTENT_GRID_TEMPLATE_SOS_SYMBOL = 'sos';
export const CONTENT_GRID_TEMPLATE_SOS_CLASSNAME = 'sage-grid-template-sos';

//
// Map for CONTENT GRID_TEMPLATE
//
export const CONTENT_GRID_TEMPLATE = {
  E: {
    CODE: CONTENT_GRID_TEMPLATE_E_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_E_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_E_CLASSNAME,
  },
  I: {
    CODE: CONTENT_GRID_TEMPLATE_I_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_I_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_I_CLASSNAME,
  },
  S: {
    CODE: CONTENT_GRID_TEMPLATE_S_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_S_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_S_CLASSNAME,
  },
  T: {
    CODE: CONTENT_GRID_TEMPLATE_T_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_T_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_T_CLASSNAME,
  },
  M: {
    CODE: CONTENT_GRID_TEMPLATE_M_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_M_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_M_CLASSNAME,
  },
  O: {
    CODE: CONTENT_GRID_TEMPLATE_O_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_O_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_O_CLASSNAME,
  },
  SE: {
    CODE: CONTENT_GRID_TEMPLATE_SE_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_SE_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_SE_CLASSNAME,
  },
  SI: {
    CODE: CONTENT_GRID_TEMPLATE_SI_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_SI_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_SI_CLASSNAME,
  },
  SS: {
    CODE: CONTENT_GRID_TEMPLATE_SS_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_SS_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_SS_CLASSNAME,
  },
  OT: {
    CODE: CONTENT_GRID_TEMPLATE_OT_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_OT_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_OT_CLASSNAME,
  },
  OM: {
    CODE: CONTENT_GRID_TEMPLATE_OM_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_OM_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_OM_CLASSNAME,
  },
  OO: {
    CODE: CONTENT_GRID_TEMPLATE_OO_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_OO_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_OO_CLASSNAME,
  },
  ET: {
    CODE: CONTENT_GRID_TEMPLATE_ET_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_ET_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_ET_CLASSNAME,
  },
  EM: {
    CODE: CONTENT_GRID_TEMPLATE_EM_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_EM_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_EM_CLASSNAME,
  },
  EO: {
    CODE: CONTENT_GRID_TEMPLATE_EO_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_EO_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_EO_CLASSNAME,
  },
  IT: {
    CODE: CONTENT_GRID_TEMPLATE_IT_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_IT_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_IT_CLASSNAME,
  },
  IM: {
    CODE: CONTENT_GRID_TEMPLATE_IM_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_IM_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_IM_CLASSNAME,
  },
  IO: {
    CODE: CONTENT_GRID_TEMPLATE_IO_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_IO_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_IO_CLASSNAME,
  },
  ST: {
    CODE: CONTENT_GRID_TEMPLATE_ST_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_ST_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_ST_CLASSNAME,
  },
  SM: {
    CODE: CONTENT_GRID_TEMPLATE_SM_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_SM_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_SM_CLASSNAME,
  },
  SO: {
    CODE: CONTENT_GRID_TEMPLATE_SO_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_SO_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_SO_CLASSNAME,
  },
  TE: {
    CODE: CONTENT_GRID_TEMPLATE_TE_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_TE_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_TE_CLASSNAME,
  },
  TI: {
    CODE: CONTENT_GRID_TEMPLATE_TI_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_TI_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_TI_CLASSNAME,
  },
  TS: {
    CODE: CONTENT_GRID_TEMPLATE_TS_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_TS_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_TS_CLASSNAME,
  },
  ME: {
    CODE: CONTENT_GRID_TEMPLATE_ME_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_ME_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_ME_CLASSNAME,
  },
  MI: {
    CODE: CONTENT_GRID_TEMPLATE_MI_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_MI_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_MI_CLASSNAME,
  },
  MS: {
    CODE: CONTENT_GRID_TEMPLATE_MS_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_MS_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_MS_CLASSNAME,
  },
  OE: {
    CODE: CONTENT_GRID_TEMPLATE_OE_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_OE_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_OE_CLASSNAME,
  },
  OI: {
    CODE: CONTENT_GRID_TEMPLATE_OI_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_OI_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_OI_CLASSNAME,
  },
  OS: {
    CODE: CONTENT_GRID_TEMPLATE_OS_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_OS_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_OS_CLASSNAME,
  },
  ETE: {
    CODE: CONTENT_GRID_TEMPLATE_ETE_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_ETE_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_ETE_CLASSNAME,
  },
  ETI: {
    CODE: CONTENT_GRID_TEMPLATE_ETI_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_ETI_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_ETI_CLASSNAME,
  },
  ETS: {
    CODE: CONTENT_GRID_TEMPLATE_ETS_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_ETS_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_ETS_CLASSNAME,
  },
  EME: {
    CODE: CONTENT_GRID_TEMPLATE_EME_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_EME_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_EME_CLASSNAME,
  },
  EMI: {
    CODE: CONTENT_GRID_TEMPLATE_EMI_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_EMI_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_EMI_CLASSNAME,
  },
  EMS: {
    CODE: CONTENT_GRID_TEMPLATE_EMS_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_EMS_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_EMS_CLASSNAME,
  },
  EOE: {
    CODE: CONTENT_GRID_TEMPLATE_EOE_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_EOE_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_EOE_CLASSNAME,
  },
  EOI: {
    CODE: CONTENT_GRID_TEMPLATE_EOI_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_EOI_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_EOI_CLASSNAME,
  },
  EOS: {
    CODE: CONTENT_GRID_TEMPLATE_EOS_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_EOS_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_EOS_CLASSNAME,
  },
  ITE: {
    CODE: CONTENT_GRID_TEMPLATE_ITE_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_ITE_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_ITE_CLASSNAME,
  },
  ITI: {
    CODE: CONTENT_GRID_TEMPLATE_ITI_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_ITI_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_ITI_CLASSNAME,
  },
  ITS: {
    CODE: CONTENT_GRID_TEMPLATE_ITS_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_ITS_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_ITS_CLASSNAME,
  },
  IME: {
    CODE: CONTENT_GRID_TEMPLATE_IME_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_IME_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_IME_CLASSNAME,
  },
  IMI: {
    CODE: CONTENT_GRID_TEMPLATE_IMI_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_IMI_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_IMI_CLASSNAME,
  },
  IMS: {
    CODE: CONTENT_GRID_TEMPLATE_IMS_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_IMS_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_IMS_CLASSNAME,
  },
  IOE: {
    CODE: CONTENT_GRID_TEMPLATE_IOE_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_IOE_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_IOE_CLASSNAME,
  },
  IOI: {
    CODE: CONTENT_GRID_TEMPLATE_IOI_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_IOI_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_IOI_CLASSNAME,
  },
  IOS: {
    CODE: CONTENT_GRID_TEMPLATE_IOS_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_IOS_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_IOS_CLASSNAME,
  },
  STE: {
    CODE: CONTENT_GRID_TEMPLATE_STE_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_STE_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_STE_CLASSNAME,
  },
  STI: {
    CODE: CONTENT_GRID_TEMPLATE_STI_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_STI_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_STI_CLASSNAME,
  },
  STS: {
    CODE: CONTENT_GRID_TEMPLATE_STS_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_STS_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_STS_CLASSNAME,
  },
  SME: {
    CODE: CONTENT_GRID_TEMPLATE_SME_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_SME_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_SME_CLASSNAME,
  },
  SMI: {
    CODE: CONTENT_GRID_TEMPLATE_SMI_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_SMI_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_SMI_CLASSNAME,
  },
  SMS: {
    CODE: CONTENT_GRID_TEMPLATE_SMS_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_SMS_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_SMS_CLASSNAME,
  },
  SOE: {
    CODE: CONTENT_GRID_TEMPLATE_SOE_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_SOE_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_SOE_CLASSNAME,
  },
  SOI: {
    CODE: CONTENT_GRID_TEMPLATE_SOI_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_SOI_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_SOI_CLASSNAME,
  },
  SOS: {
    CODE: CONTENT_GRID_TEMPLATE_SOS_CODE,
    SYMBOL: CONTENT_GRID_TEMPLATE_SOS_SYMBOL,
    CLASSNAME: CONTENT_GRID_TEMPLATE_SOS_CLASSNAME,
  },
};
